export default "__VITE_ASSET__B_7EGI_b__"